/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Overlap_Protection_HelpInputs */

const en_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prevent events from overlapping in the Timeline.`)
};

const fr_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empêcher les événements de se chevaucher dans la timeline.`)
};

const de_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhindern Sie, dass sich Ereignisse in der Zeitleiste überschneiden.`)
};

const it_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impedisci la sovrapposizione degli eventi nella sequenza temporale.`)
};

const ru_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предотвратите наложение событий на временной шкале.`)
};

const es_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evitar que los eventos se superpongan en la línea de tiempo.`)
};

const zh_cn2_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防止时间线中的事件重叠。`)
};

const ja_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインでイベントが重複するのを防ぎます。`)
};

const hi_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन में घटनाओं को एक-दूसरे के ऊपर आने से रोकें।`)
};

const pt_pt2_options_editor_overlap_protection_help = /** @type {(inputs: Options_Editor_Overlap_Protection_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impeça que os eventos se sobreponham na Linha do Tempo.`)
};

/**
* | output |
* | --- |
* | "Prevent events from overlapping in the Timeline." |
*
* @param {Options_Editor_Overlap_Protection_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_overlap_protection_help = /** @type {((inputs?: Options_Editor_Overlap_Protection_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Overlap_Protection_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_overlap_protection_help(inputs)
	if (locale === "de") return de_options_editor_overlap_protection_help(inputs)
	if (locale === "it") return it_options_editor_overlap_protection_help(inputs)
	if (locale === "ru") return ru_options_editor_overlap_protection_help(inputs)
	if (locale === "es") return es_options_editor_overlap_protection_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_overlap_protection_help(inputs)
	if (locale === "ja") return ja_options_editor_overlap_protection_help(inputs)
	if (locale === "hi") return hi_options_editor_overlap_protection_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_overlap_protection_help(inputs)
	return en_options_editor_overlap_protection_help(inputs)
});